import BrokersTable from "./BrokersTable"

export default BrokersTable
